import styled from 'styled-components';

/** The design's card, holding four cells rather than four separate cards. */
export const Card = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin-bottom: var(--s5);
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  box-shadow: var(--sh-1);
  overflow: hidden;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const Cell = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--s2);
  padding: var(--s3) var(--s5);

  /* Hairlines between, never around — the card's own edge closes the ends. */
  & + & {
    border-left: 1px solid var(--line);
  }

  @media (max-width: 1100px) {
    &:nth-child(odd) {
      border-left: none;
    }

    &:nth-child(n + 3) {
      border-top: 1px solid var(--line);
    }
  }
`;

/** For Total, which has no status chip to label it. */
export const PlainLabel = styled.div`
  font-size: var(--fs-label);
  font-weight: var(--fw-medium);
  line-height: var(--lh-body);
  color: var(--text-muted);
`;

/**
 * The number. Mono with tabular numerals like every other count in the
 * panel, and at --fs-title, the largest size the scale has — this is a
 * summary strip and the figures are the whole of it.
 */
export const Count = styled.div`
  font-family: var(--font-mono);
  font-size: var(--fs-title);
  font-weight: var(--fw-medium);
  font-variant-numeric: tabular-nums;
  line-height: 1;
  color: var(--text);
`;
